var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('nav',{staticClass:"navi main-nav"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'NIS Connections Table' }}},[_vm._v("TABLE")])],1),_c('li',[_c('router-link',{attrs:{"to":{ name: 'NIS Connections Map' }}},[_vm._v("MAP")])],1)])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }